module.exports = __webpack_public_path__ + "img/P4-0.c8b6117b.jpg";